import React from 'react';
import PropTypes from 'prop-types';
import Button from "../Button";
import Modal from './Modal';
import common from '../../../common/common';

class ConfirmModal extends React.Component {
    constructor(props) {
        super(props);
    }

    static defaultProps = {
        visible: false,
        showPendant: false,
        title: '',
        content: '',
        okText: '',
        okType: 'primary',
        okButtonProps: {},
        onOk: null,
        showCancel: true,
        cancelText: '',
        cancelType: 'default',
        cancelButtonProps: {},
        onCancel: null,
        close: null,
        afterClose: null
    };

    static propTypes = {
        visible: PropTypes.bool, // 弹窗是否展示
        showPendant: PropTypes.bool, // 弹窗是否展示顶部挂件
        // 弹窗标题
        title: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        // 弹窗内容
        content: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node
        ]),
        okText: PropTypes.string, // 确定按钮文案
        okType: PropTypes.string, // 确定按钮type值
        okButtonProps: PropTypes.object, // 确定按钮 props
        onOk: PropTypes.func, // 点击确定按钮后的回调
        showCancel: PropTypes.bool, // 是否展示取消按钮
        cancelText: PropTypes.string, // 取消按钮文案
        cancelType: PropTypes.string, // 取消按钮type值
        cancelButtonProps: PropTypes.object, // 取消按钮props
        onCancel: PropTypes.func, // 点击取消按钮/关闭按钮后的回调
        close: PropTypes.func, // 关闭弹窗方法
        afterClose: PropTypes.func, // Modal完全关闭后的回调
    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState) {
        // Modal完全关闭后的回调
        if (!this.props.visible && prevProps.visible) {
            typeof this.props.afterClose === 'function' && this.props.afterClose();
        }
    }

    // 点击确定按钮后的回调
    onOk = async(e) => {
        try {
            const { onOk, close } = this.props;
            if (typeof onOk === 'function') await onOk(e);
            close();
        } catch(error) {
        }
    };

    // 点击取消按钮后的回调
    onCancel = async (e) => {
        try {
            const { onCancel, close } = this.props;
            if (typeof onCancel === 'function') await onCancel(e);
            close();
        } catch(error) {
        }
    };


    render() {
        const { content, okText, okType, okButtonProps, showCancel, cancelText, cancelType, cancelButtonProps, close,  ...props } = this.props;

        const footer = (
            <ul className="modal-btnList">
                {
                    showCancel && (
                        <li>
                            <Button
                                onClick={this.onCancel}
                                type={cancelType}
                                {...cancelButtonProps}
                            >
                                {cancelText}
                            </Button>
                        </li>
                    )
                }
                <li>
                    <Button
                        onClick={this.onOk}
                        type={okType}
                        {...okButtonProps}
                    >
                        {okText}
                    </Button>
                </li>
            </ul>
        );

        return (
            <Modal
                {...props}
                showPendant={!common.isPhone()}
                footer={footer}
                onCancel={() => close({ triggerCancel: true })}
            >
                {
                    content
                }
            </Modal>
        )
    }
}

export default ConfirmModal;